import type * as Types from '../../../__generated__/bffGlobalTypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type BuyerAppointmentsVariables = Types.Exact<{ [key: string]: never; }>;


export type BuyerAppointments = {
  buyerAppointments: Array<{
    __typename?: 'BuyerAppointment',
    readableAddress: string,
    scheduledTime: string | null,
    state: Types.TourRequestState,
    customer: {
      __typename?: 'ContactData',
      email: string | null,
      fullName: string | null,
      phoneNumber: string | null
    }
  }>
};


export const BuyerAppointmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BuyerAppointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyerAppointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"readableAddress"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledTime"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<BuyerAppointments, BuyerAppointmentsVariables>;